import React from 'react';
import { Link } from 'react-router-dom';
import { array } from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import Card from '../Card/Card';
import { FMessage } from '../../hoc/IntlComponents';

const propTypes = {
  countries: array.isRequired,
  intl: intlShape.isRequired,
};

const defaultProps = {
  countries: [],
  intl: function() {},
};

const getTitle = intl =>
  intl.formatMessage({
    id: 'offer.geo.title',
    defaultMessage: 'Geo',
  });

const getLabel = intl =>
  intl.formatMessage({
    id: 'offer.geo.show-all',
    defaultMessage: 'Display all countries',
  });

const OfferGeoList = ({
  countries,
  intl,
  offerId,
  forbiddenGeo,
  collapsing,
  withoutControls,
  isGambling,
}) => {
  const getControls = () => {
    return [
      <Link
        to={`/tickets/create?theme=geoRequest&offer=${offerId}`}
        className={withoutControls ? '' : 'btn btn-primary btn-sm'}
      >
        <FMessage id="offer.buttons.geo-request" />
      </Link>,
    ];
  };
  const getItems = () => {
    if (!countries.length) {
      if (forbiddenGeo && forbiddenGeo.length > 0) {
        return [<FMessage id="offer.geo-list.all" />];
      }
      return [<FMessage id="offer.geo-prices.no-limits" />];
    } else {
      return countries;
    }
  };
  return (
    <Card.Collapsible
      alwaysVisibleItem={withoutControls && getControls()}
      collapsing={collapsing}
      title={getTitle(intl)}
      label={getLabel(intl)}
      items={getItems()}
      visibleItems={3}
      controls={withoutControls || isGambling ? [] : getControls()}
    />
  );
};

OfferGeoList.propTypes = propTypes;
OfferGeoList.defaultProps = defaultProps;

export default injectIntl(OfferGeoList);
